export default __webpack_public_path__ + "static/media/ct213-1.f83b4ae2.png";